import React, { Component } from 'react';
import FormicaInput from '../../custom/FormicaInput';
import RoleHelper from '../../../RoleHelper';
import AnimatedButton from '../../custom/AnimatedButton';
import { RadioButton, RadioButtonChangeParams } from 'primereact/radiobutton';
import { FormicaProps, withFormica } from '../../../helpers/withFormica';
import { RootState } from '../../../redux/store';
import { TrackerState } from '../../../redux/reducers/TrackerReducer';
import { changeTracker } from '../../../redux/actions/TrackerActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import TrackerTypeUtil from '../../../util/TrackerTypeUtil';
import Icon from '../../../icons/Icon';
import FormicaLabel from '../../custom/FormicaLabel';
import TrackerVariable, {
  TrackerCookieVariable,
  TrackerElementVariable,
  TrackerEventVariable,
  TrackerJavascriptVariable,
  TrackerUrlVariable,
} from '../../../domain/tracker/variable/TrackerVariable';
import { TrackerVariableTypeMobile, TrackerVariableTypeWeb } from '../../../domain/tracker/TrackerVariableType';
import MessageUtil from '../../../util/MessageUtil';
import TrackerUrlVariableComponent from './variable/TrackerUrlVariableComponent';
import TrackerElementVariableComponent from './variable/TrackerElementVariableComponent';
import TrackerCookieVariableComponent from './variable/TrackerCookieVariableComponent';
import TrackerJavascriptVariableComponent from './variable/TrackerJavascriptVariableComponent';
import TrackerEventVariableComponent from './variable/TrackerEventVariableComponent';
import _ from 'lodash';
import LanguageUtil from '../../../util/LanguageUtil';
import TrackerFilterJsonModel from '../../../domain/tracker/filter/TrackerFilterJsonModel';
import TrackerFilterComponent from './TrackerFilterComponent';
import { APP_LIST_FILTER_FIELDS } from '../../../domain/tracker/filter/AppListFilterField';
import DataType from '../../../constant/DataType';
import FormicaMultiSelectBox from '../../custom/FormicaMultiSelectBox';
import { ANDROID_PERMISSIONS } from '../../../domain/tracker/filter/AndroidPermission';
import { FormicaSelectBoxItem } from '../../custom/FormicaSearchSelectBox';

class TrackerVariableContentComponent extends Component<Props, State> {
  public state: State = new State();

  public render() {
    const {
      tracker: { tracker },
      onHide,
    } = this.props;
    const { variable } = this.state;
    return (
      <div className={'flex flex-col h-full w-full'}>
        <div className={'border-b'}>
          <span className={'text-f-black-2 font-semibold'}>{LanguageUtil.get({ id: 'common.label.type', defaultMessage: 'Type' })}</span>
          <div className={'max-h-[500px] overflow-y-scroll'}>
            {TrackerTypeUtil.getVariableTypeOptions(tracker.platform).map(
              (
                data: {
                  value: TrackerVariable & { icon: string };
                  label: string;
                },
                index,
              ) => {
                return (
                  <div className={'flex items-center gap-x-2 py-2'} key={index}>
                    <RadioButton
                      inputId={data.value.type}
                      name={data.label}
                      value={data.value}
                      onChange={this.onChangeType}
                      checked={variable.type == data.value.type}
                    />
                    <div className={'w-7 h-7 bg-[#EFF2FE] rounded-full flex items-center justify-center'}>
                      <Icon icon={data.value.icon || 'tracker-appstatechange'} size={tracker.platform == 'MOBILE' ? 16 : 18} color={'#728EFF'} />
                    </div>
                    <div className={'flex flex-col'}>
                      <span className={'text-f-black-2 text-[13px]'}>{this.formatEnumLabel(data.label)}</span>
                      <span className={'text-f-black-3 text-[10px]'}>Description</span>
                    </div>
                  </div>
                );
              },
            )}
          </div>
        </div>
        <div className={'border-b py-5'}>
          <div className={'flex flex-col gap-y-1'}>
            <FormicaLabel label={LanguageUtil.get({ id: 'common.label.name', defaultMessage: 'Name' })} />
            <FormicaInput
              onChange={this.onChangeName}
              value={variable.name}
              name={'name'}
              label={'Name'}
              placeholder={LanguageUtil.get({ id: 'common.input.placeholder.name', defaultMessage: 'Name' })}
              type={'text'}
              disabled={!RoleHelper.canEdit('Tracker')}
            />
          </div>
        </div>
        <div className={'border-b py-5'}>
          <div className={'flex flex-col gap-y-1'}>
            <FormicaLabel label={LanguageUtil.get({ id: 'common.label.description', defaultMessage: 'Description' })} />
            <FormicaInput
              value={variable.description}
              name={'Description'}
              onChange={this.onChangeDescription}
              type={'text'}
              placeholder={LanguageUtil.get({ id: 'common.input.placeholder.description', defaultMessage: 'Description' })}
              disabled={!RoleHelper.canEdit('Tracker')}
            />
          </div>
        </div>
        {this.getVariableFields()}
        <div className={'py-5 flex gap-x-4 justify-end'}>
          <AnimatedButton
            text={LanguageUtil.get({ id: 'common.button.cancel', defaultMessage: 'Cancel' })}
            customType={'secondary'}
            customSize={'sm'}
            icon={'multiplier'}
            onClick={this.onHide}
            disabled={!RoleHelper.canEdit('Tracker')}
          />
          <AnimatedButton
            text={LanguageUtil.get({ id: 'common.button.apply', defaultMessage: 'Apply' })}
            customType={'primary'}
            customSize={'sm'}
            icon={'add'}
            onClick={this.apply}
            disabled={!RoleHelper.canEdit('Tracker')}
          />
        </div>
      </div>
    );
  }

  public componentDidMount() {
    const { selectedData } = this.props;
    if (selectedData) {
      const clonedVariable: TrackerVariable = _.cloneDeep(selectedData);
      if (clonedVariable.type === TrackerVariableTypeMobile.APP_LIST) {
        if (!clonedVariable.filters) {
          clonedVariable.filters = [];
        }
        if (!clonedVariable.inPermissions) {
          clonedVariable.inPermissions = [];
        }
      }
      this.setState({ variable: clonedVariable });
    }
  }

  public componentDidUpdate(prevProps: Props) {
    if ((this.props.selectedData && this.props.selectedData !== prevProps.selectedData) || (this.props.visible && !prevProps.visible)) {
      const clonedVariable: TrackerVariable = _.cloneDeep(this.props.selectedData);
      if (clonedVariable && clonedVariable.type === TrackerVariableTypeMobile.APP_LIST) {
        if (!clonedVariable.filters) {
          clonedVariable.filters = [];
        }
        if (!clonedVariable.inPermissions) {
          clonedVariable.inPermissions = [];
        }
      }
      this.setState({ variable: clonedVariable || ({} as TrackerVariable) });
    }
  }

  private formatEnumLabel(label: string): string {
    const formattedLabel = label.toLowerCase().replace(/_/g, ' ');
    return formattedLabel.replace(/\b\w/g, (char) => char.toUpperCase());
  }

  private onChangeName = (e: React.FormEvent<HTMLInputElement>) => {
    const { variable } = this.state;
    variable.name = e.currentTarget.value;
    this.setState({ variable });
  };

  private onChangeDescription = (e: React.FormEvent<HTMLInputElement>) => {
    const { variable } = this.state;
    variable.description = e.currentTarget.value;
    this.setState({ variable });
  };

  private onChangeType = (e: RadioButtonChangeParams) => {
    const { variable } = this.state;
    const newVariable = e.value as TrackerVariable;
    newVariable.name = variable.name;
    newVariable.description = variable.description;
    if (newVariable.type === TrackerVariableTypeMobile.APP_LIST) {
      if (!newVariable.filters) {
        newVariable.filters = [];
      }
      if (!newVariable.inPermissions) {
        newVariable.inPermissions = [];
      }
    }
    this.setState({ variable: newVariable as TrackerVariable, selectedFieldDataType: undefined, filters: [] });
  };

  private apply = () => {
    const {
      setSelectedData,
      selectedData,
      tracker: { tracker },
    } = this.props;
    const { variable } = this.state;
    if (variable.name == undefined || variable.name == '') {
      MessageUtil.error({
        summary: 'Tracker',
        detail: <div>Name is required.</div>,
      });
      return;
    }
    if (variable.name != selectedData?.name && tracker.variables.some((t) => t.name == variable.name)) {
      return MessageUtil.error({
        summary: 'Tracker',
        detail: <div>Variable name already used.</div>,
      });
    }
    setSelectedData(variable);
    this.setState({ selectedFieldDataType: undefined, filters: [] });
    MessageUtil.success({
      summary: 'Tracker',
      detail: <div>Variable updated.</div>,
    });
  };

  private getVariableFields = () => {
    const { variable } = this.state;
    switch (variable.type) {
      case TrackerVariableTypeWeb.URL:
        return <TrackerUrlVariableComponent variable={variable as TrackerUrlVariable} onChange={this.onChangeVariable} />;
      case TrackerVariableTypeWeb.ELEMENT:
        return <TrackerElementVariableComponent variable={variable as TrackerElementVariable} onChange={this.onChangeVariable} />;
      case TrackerVariableTypeWeb.COOKIE:
        return <TrackerCookieVariableComponent variable={variable as TrackerCookieVariable} onChange={this.onChangeVariable} />;
      case TrackerVariableTypeWeb.JAVASCRIPT:
        return <TrackerJavascriptVariableComponent variable={variable as TrackerJavascriptVariable} onChange={this.onChangeVariable} />;
      case TrackerVariableTypeWeb.EVENT:
        return <TrackerEventVariableComponent variable={variable as TrackerEventVariable} onChange={this.onChangeVariable} />;
      case TrackerVariableTypeWeb.CUSTOM:
        return null;
      case TrackerVariableTypeMobile.APP_LIST:
        return this.getAppListFilterFields();
    }
  };

  private getAppListFilterFields = () => {
    const { variable, filters, selectedFieldDataType } = this.state;
    const variableFilters = variable.filters || [];
    const newFilter = filters.length > 0 ? filters[filters.length - 1] : { field: '', operator: undefined, value: '' };
    const fieldOptions = APP_LIST_FILTER_FIELDS.map((fieldInfo) => ({
      label: fieldInfo.label,
      value: fieldInfo.field,
      dataType: fieldInfo.dataType,
    }));
    const inPermissions = variable.inPermissions || [];
    const permissionOptions: FormicaSelectBoxItem[] = ANDROID_PERMISSIONS.map((perm) => ({
      label: perm.title,
      value: perm.value,
    }));
    const selectedPermissions: FormicaSelectBoxItem[] = inPermissions.map((perm: string) => {
      const permission = ANDROID_PERMISSIONS.find((p) => p.value === perm);
      return {
        label: permission?.title || perm,
        value: perm,
      };
    });

    return (
      <>
        <div className={'border-b py-5'}>
          <div className={'flex flex-col gap-y-1'}>
            <FormicaLabel label={LanguageUtil.get({ id: 'common.label.permissions', defaultMessage: 'Permissions' })} />
            <FormicaMultiSelectBox
              selectedItems={selectedPermissions}
              onChange={(items: FormicaSelectBoxItem[]) => {
                const updatedVariable = { ...variable };
                updatedVariable.inPermissions = items.map((item) => item.value);
                this.setState({ variable: updatedVariable });
              }}
              options={permissionOptions}
              disabled={!RoleHelper.canEdit('Tracker')}
              placeholder={LanguageUtil.get({ id: 'common.input.placeholder.permissions', defaultMessage: 'Select Permissions' })}
              rounded
            />
          </div>
        </div>
        <TrackerFilterComponent
          fieldOptions={fieldOptions}
          filters={variableFilters}
          newFilter={newFilter}
          selectedFieldDataType={selectedFieldDataType}
          onAddFilter={this.addFilter}
          onUpdateFilter={this.updateFilter}
          onUpdateNewFilter={(key, value) => {
            const targetIndex = filters.length > 0 ? filters.length - 1 : -1;
            this.updateFilters(targetIndex, key, value);
          }}
          onRemoveFilter={this.removeFilter}
          onSelectedFieldChange={(field, dataType) => this.setState({ selectedFieldDataType: dataType })}
        />
      </>
    );
  };

  private addFilter = () => {
    const { variable, filters } = this.state;
    if (!variable.filters) {
      variable.filters = [];
    }
    if (filters.length > 0) {
      const lastFilter = filters[filters.length - 1];
      if (lastFilter.field || lastFilter.operator || lastFilter.value) {
        variable.filters.push(lastFilter);
      }
    }
    this.setState({
      variable,
      filters: [{ field: '', operator: undefined, value: '' }],
      selectedFieldDataType: undefined,
    });
  };

  private updateFilter = (index: number, key: keyof TrackerFilterJsonModel, value: any) => {
    const { variable } = this.state;
    if (variable.filters) {
      variable.filters[index][key] = value;
      this.setState({ variable });
    }
  };

  private updateFilters = (index: number, key: keyof TrackerFilterJsonModel, value: any) => {
    const { filters } = this.state;
    let updatedFilters = [...filters];
    if (updatedFilters.length === 0) {
      updatedFilters.push({ field: '', operator: undefined, value: '' });
    }
    const targetIndex = index >= 0 ? index : updatedFilters.length - 1;
    updatedFilters[targetIndex] = { ...updatedFilters[targetIndex], [key]: value };
    this.setState({ filters: updatedFilters });
  };

  private removeFilter = (index: number) => {
    const { variable } = this.state;
    if (variable.filters) {
      variable.filters.splice(index, 1);
      this.setState({ variable });
    }
  };

  private onChangeVariable = (variable: TrackerVariable) => {
    this.setState({ variable });
  };

  private onHide = () => {
    const { onHide } = this.props;
    this.setState({
      variable: {} as TrackerVariable,
      selectedFieldDataType: undefined,
      filters: [],
    });
    onHide();
  };
}

class State {
  variable: TrackerVariable = {} as TrackerVariable;
  filters: TrackerFilterJsonModel[] = [];
  selectedFieldDataType: DataType | undefined;
}

interface Props extends FormicaProps, ReduxProps {
  selectedData: TrackerVariable | undefined;
  setSelectedData: (data: TrackerVariable) => void;
  onHide: () => void;
  visible: boolean;
}

const mapStateToProps = (state: RootState) => ({
  tracker: state.tracker as TrackerState,
});

const mapDispatchToProps = {
  changeTracker,
};
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default withFormica(connector(TrackerVariableContentComponent));
